import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class ToastService {

  private readonly DEFAULT_DURATION: number = 5;
  private readonly DEFAULT_MILLISECONDS: number = 1000;

  private closeButton: string;

  constructor(
    private snackbar: MatSnackBar,
    private translateService: TranslateService
  ) {
    this.closeButton = this.translate('commons.buttons.ok');
  }

  public show(message: string, duration: number = this.DEFAULT_DURATION): void {
    this.open(this.translate(message), '', duration);
  }

  public error(message: string): void {
    this.open(this.translate(message), this.closeButton);
  }

  private open(message: string, action: string = '', duration: number = 0): void {
    const options: SnackbarOptions = {
      horizontalPosition: 'center',
      verticalPosition: 'bottom'
    };
    if (duration) {
      options.duration = duration * this.DEFAULT_MILLISECONDS;
    }
    this.snackbar.open(message, action, options);
  }

  private translate(value: string): string {
    return this.translateService.instant(value);
  }

}

interface SnackbarOptions {
  horizontalPosition?: MatSnackBarHorizontalPosition;
  verticalPosition?: MatSnackBarVerticalPosition;
  duration?: number;
}
